import Avatar from "@/components/Avatar";
import type { MaterialNames } from "@/components/material_symbol_names";
import type { ReactNode } from "react";

type DashboardRowDetailsProps = {
  picture?: string;
  icon?: MaterialNames;
  title: ReactNode;
  text?: ReactNode;
  secondaryText?: string;
};

export default function DashboardRowDetails({
  picture,
  title,
  text,
  secondaryText,
  icon = "person"
}: DashboardRowDetailsProps) {
  return (
    <div className="flex min-w-0 items-center">
      <Avatar picture={picture} iconName={icon} className="min-w-[3rem] shrink-0" />
      <div className="ml-2 min-w-0">
        {secondaryText ? (
          <div className="text-body-small text-sys-brand-on-surface-variant">{secondaryText}</div>
        ) : null}
        <div className="line-clamp-2 break-words text-body-medium">{title}</div>
        {text ? (
          <div className="line-clamp-2 break-words text-body-small text-sys-brand-on-surface-variant">{text}</div>
        ) : null}
      </div>
    </div>
  );
}
